import { API_PASSWORD } from './config';
import { getSubdomain, fetchWithAuth } from './helpers';

// اضافة مجموعه////////
export const createCategoryGroup = async (formDataInput) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/save/category`;

  const formData = new FormData();
  formData.append("api_password", API_PASSWORD);
  formData.append("name", formDataInput.name);
  formData.append("kitchen_id", formDataInput.kitchen_id);
  formData.append("note", formDataInput.note);
  formData.append("printer_id", formDataInput.printer_id);

  if (formDataInput.image) {
    formData.append("image", formDataInput.image);
  } else {
    // ✅ Use local assets/category.png as default image
    try {
      // Dynamically import the image file
      const defaultImageModule = await import('../assets/Virtualimagesofitems/category.png');
      const defaultImageUrl = defaultImageModule.default;
      // Fetch the image as a blob
      const response = await fetch(defaultImageUrl);
      const blob = await response.blob();
      formData.append("image", blob, "category.png");
    } catch (err) {
      console.error("❌ لم يتم العثور على الصورة الافتراضية category.png:", err);
    }
  }

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true); // ✅ true معناها: isFormData = true, requireToken = true

  const data = await response.json();

  if (!response.ok) {
    const errorMessage = data.message || "❌ فشل في إنشاء مجموعة الأصناف.";
    throw new Error(errorMessage);
  }

  return data;
};


// عرض المجاميع

export const getAllCategoryGroups = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/categories?api_password=${API_PASSWORD}`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET"
  }, false);

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في جلب المجموعات.");
  }

  // ✅ نفك التغليف الداخلي هنا
  return Array.isArray(data.data) && Array.isArray(data.data[0])
    ? data.data[0]
    : data.data;
};

// ///////تعديل بيانات المجموعه

export const updateCategoryGroup = async (formDataInput) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/category`;

  const formData = new FormData();
  formData.append("api_password", API_PASSWORD);
  formData.append("id", formDataInput.id);
  formData.append("name", formDataInput.name);
  formData.append("kitchen_id", formDataInput.kitchen_id);
  formData.append("root_id", formDataInput.root_id);
  formData.append("note", formDataInput.note || '');
  formData.append("price", formDataInput.price || '');
    formData.append("printer_id", formDataInput.printer_id);


  if (formDataInput.image) {
    formData.append("image", formDataInput.image); // صورة جديدة إن وُجدت
  }

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData
  }, true); // isFormData = true

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تعديل المجموعة.");
  }

  return data;
};




// اضافة منتج جديد/////
export const addProducts = async (products) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/save/products`;

  const formData = new FormData();
  formData.append("api_password", API_PASSWORD);

  // تأكد من إرسال المنتجات المكتملة فقط
  for (const product of products) {
    if (product.name && product.price && product.category_id) {
      formData.append("name[]", product.name);
      formData.append("price[]", product.price);
      formData.append("description[]", product.description || '');
      formData.append("category_id[]", product.category_id);
      formData.append("product_cost[]", product.product_cost || '');
      formData.append("is_preparing[]", product.is_preparing || '0');
      formData.append("preparing_time[]", product.preparing_time || '');
      // معالجة الصورة

      if (product.image) {
        formData.append("image[]", product.image);
      } else {
        // ✅ استخدم صورة افتراضية من assets إذا لم يتم اختيار صورة
        try {
          const defaultImageModule = await import('../assets/Virtualimagesofitems/category.png');
          const defaultImageUrl = defaultImageModule.default;
          const response = await fetch(defaultImageUrl);
          const blob = await response.blob();
          formData.append("image[]", blob, "category.png");
        } catch (err) {
          // إذا فشل تحميل الصورة الافتراضية، أرسل صورة فارغة
          formData.append("image[]", new Blob());
        }
      }
    }
  }

  // ✅ طباعة ما سيتم إرساله
  console.log("📦 محتويات FormData قبل الإرسال:");
  for (let pair of formData.entries()) {
    console.log(`${pair[0]}:`, pair[1]);
  }

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true);

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ API Error:", data);
    if (data.errors) {
      Object.entries(data.errors).forEach(([field, messages]) => {
        console.error(`❗خطأ في الحقل "${field}":`, messages);
      });
    }
    throw new Error(data.message || "❌ فشل في إضافة المنتجات.");
  }

  return data;
};


// /////////عرض كل المنتجات 
export const getAllProducts = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/products?api_password=${API_PASSWORD}`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET"
  }, false);

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في جلب المنتجات.");
  }

  return data; // ✅ هنا نرجع data نفسها، بدون .data
};




////////////// تعديل بيانات الاصناف 
export const updateProduct = async (productData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/product`;

  const formData = new FormData();
  formData.append("api_password", API_PASSWORD);
  formData.append("id", productData.id);
  formData.append("category_id", productData.category_id);
  formData.append("price", productData.price);
  formData.append("name", productData.name);
  formData.append("description", productData.description);

  if (productData.image) {
    formData.append("image", productData.image);
  }

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true); // true for FormData

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ API Error:", data);
    throw new Error(data.message || "❌ فشل في تعديل المنتج.");
  }

  return data;
};




////// رفع المنتجات من خلال الاكسسيل 
export const importProductsFromFile = async (importData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/import/products?api_password=${API_PASSWORD}`;

  const formData = new FormData();
  formData.append("category_id", importData.category_id);
  formData.append("file", importData.file);

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true); // ✅ true = isFormData, وهو مهم

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ API Error:", data);
    throw new Error(data.message || "❌ فشل في استيراد المنتجات.");
  }

  return data;
};

export const linkOfferToBranch = async (offer_id) => {
  const subdomain = getSubdomain();
  const root_id = localStorage.getItem("branch_id");

  const apiUrl = `https://${subdomain}.restocash.app/api/add/offer/root?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      offer_id,
      root_id: Number(root_id),
    }),
  }, true);

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في ربط العرض بالفرع:", data);
    throw new Error(data?.message || "❌ فشل في ربط العرض.");
  }

  console.log("✅ تم ربط العرض:", data);
  return data;
};

// تغيير حالة المنتج (تفعيل/إلغاء تفعيل)
export const changeProductStatus = async (productId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/change/product/status/${productId}?api_password=${API_PASSWORD}`;
  const token = localStorage.getItem("token");

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تغيير حالة المنتج.");
  }

  return data;
};

// تغيير حالة المجموعة (تفعيل/إلغاء تفعيل)
export const changeCategoryGroupStatus = async (categoryId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/change/category/status/${categoryId}?api_password=${API_PASSWORD}`;
  const token = localStorage.getItem("token");

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تغيير حالة المجموعة.");
  }

  return data;
};
